import React, { useContext } from "react";
import './Footer.scss';
import Grid from '@material-ui/core/Grid';
import Utils from 'utils/Utils';
import { SettingsContext } from 'Providers/SettingsProvider';

import {
  FacebookIcon,
} from "react-share";

function FooterInner() {
  const { translate, settings, t } = useContext(SettingsContext);
  return <div className="footer-inner">
    <Grid container spacing={1}>
      <Grid item xs={6} md={3} className="footer-inner-cartouche">
        {Utils.parseWithLinks(translate(settings,'footer1'))}
      </Grid>
      <Grid item xs={6} md={3} className="footer-inner-cartouche">
        {Utils.parseWithLinks(translate(settings,'footer2'))}
      </Grid>
      <Grid item xs={6} md={3} className="footer-inner-cartouche">
        {Utils.parseWithLinks(translate(settings,'footer3'))}
      </Grid>
      <Grid item xs={6} md={3} className="rs">
        <a href="https://www.facebook.com/centredartlelait" target="_blank" rel="noreferrer"><FacebookIcon round size={30}/></a>
        <a href="https://www.instagram.com/centredartlelait/" target="_blank" rel="noreferrer">
          <svg className="insta" width="24" height="24" viewBox="0 0 24 24">
            <path d="M14.667 12c0 1.473-1.194 2.667-2.667 2.667-1.473 0-2.667-1.193-2.667-2.667 0-1.473 1.194-2.667 2.667-2.667 1.473 0 2.667 1.194 2.667 2.667zm3.846-3.232c.038.843.046 1.096.046 3.232s-.008 2.389-.046 3.233c-.1 2.15-1.109 3.181-3.279 3.279-.844.038-1.097.047-3.234.047-2.136 0-2.39-.008-3.232-.046-2.174-.099-3.181-1.132-3.279-3.279-.039-.845-.048-1.098-.048-3.234s.009-2.389.047-3.232c.099-2.152 1.109-3.181 3.279-3.279.844-.039 1.097-.047 3.233-.047s2.39.008 3.233.046c2.168.099 3.18 1.128 3.28 3.28zm-2.405 3.232c0-2.269-1.84-4.108-4.108-4.108-2.269 0-4.108 1.839-4.108 4.108 0 2.269 1.84 4.108 4.108 4.108 2.269 0 4.108-1.839 4.108-4.108zm1.122-4.27c0-.53-.43-.96-.96-.96s-.96.43-.96.96.43.96.96.96c.531 0 .96-.43.96-.96zm6.77-7.73v24h-24v-24h24zm-4 12c0-2.172-.009-2.445-.048-3.298-.131-2.902-1.745-4.52-4.653-4.653-.854-.04-1.126-.049-3.299-.049s-2.444.009-3.298.048c-2.906.133-4.52 1.745-4.654 4.653-.039.854-.048 1.127-.048 3.299 0 2.173.009 2.445.048 3.298.134 2.906 1.746 4.521 4.654 4.654.854.039 1.125.048 3.298.048s2.445-.009 3.299-.048c2.902-.133 4.522-1.745 4.653-4.654.039-.853.048-1.125.048-3.298z"/>
          </svg>
        </a>
        <a className="news" href="https://contacts.centredartlelait.com/inscription.php?cat=372" target="_blank" rel="noreferrer">{t('newsletter')}</a>
      </Grid>
      <Grid item xs={12}>
        <div className="spacer"></div>
        {Utils.parseWithLinks(translate(settings,'footer4'))}
      </Grid>
    </Grid>
  </div>;
}

export default FooterInner;
